export const ID_OTHER_RESIDENCE = '2';
